export const getCode = (state) => state.code && state.code.value;
